import { Component, input } from '@angular/core';
import { CoreJssProxyModule, TextField } from '@core/jss-proxy';

@Component({
  selector: 'wl-content-top-tasks-section',
  standalone: true,
  imports: [CoreJssProxyModule],
  templateUrl: './content-top-tasks-section.component.html',
  styleUrls: [
    './content-top-tasks-section.component.ed.scss',
    './content-top-tasks-section.component.essent.scss',
  ],
})
export class ContentTopTasksSectionComponent {
  readonly heading = input.required<TextField>();
  readonly ariaLabel = input('toptaak-navigatie');
}
